import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  useGetLatestAnalysisResults,
  useGetLatestProjectAnalysis,
} from "../work-mgmt-services";
import { useParams } from "react-router-dom";

const ProjectOverviewContext = createContext();

export const ProjectOverviewProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [droppingItem, setDroppingItem] = useState(null);
  const [isTrainModalVisible, setIsTrainModalVisible] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [viewType, setViewType] = useState("multiTableView");
  const [selectedInsight, setSelectedInsight] = useState(null);
  const [tasksByInsights, setTasksByInsights] = useState([]);
  const [createFilterOpen, setCreateFilterOpen] = useState(false);
  const [editFiltersCount, setEditFiltersCount] = useState(0);
  let { project_id_from_params } = useParams();
  const [project_id, setProjectId] = useState(
    project_id_from_params ?? undefined,
  );
  const [keyActivityProvider, setKeyActivityProvider] = useState(null);

  const {
    data: projectAnalysis,
    isSuccess: projectAnalysisSuccess,
    isLoading: projectAnalysisLoading,
    isError: projectAnalysisError,
    refetch: refetchProjectAnalysisResults,
  } = useGetLatestProjectAnalysis(project_id);

  const {
    data: analysisResults,
    isSuccess: analysisResultsSuccess,
    isLoading: analysisResultsLoading,
    isError: analysisResultsError,
    refetch: refetchAnalysisResults,
  } = useGetLatestAnalysisResults(
    project_id,
    projectAnalysis?.key_activity,
    projectAnalysisSuccess,
  );

  useEffect(() => {
    if (projectAnalysisSuccess && projectAnalysis) {
      setKeyActivityProvider(projectAnalysis.key_activity);
    }
  }, [projectAnalysisSuccess, projectAnalysis]);

  const [cols, setCols] = useState(3);

  return (
    <ProjectOverviewContext.Provider
      value={{
        items,
        setItems,
        droppingItem,
        setDroppingItem,
        isTrainModalVisible,
        setIsTrainModalVisible,
        isFilterOpen,
        setIsFilterOpen,
        viewType,
        setViewType,
        selectedInsight,
        setSelectedInsight,
        tasksByInsights,
        setTasksByInsights,
        createFilterOpen,
        setCreateFilterOpen,
        editFiltersCount,
        setEditFiltersCount,
        project_id,
        setProjectId,
        analysisResults,
        analysisResultsSuccess,
        analysisResultsLoading,
        analysisResultsError,
        refetchAnalysisResults,
        cols,
        setCols,
        projectAnalysis,
        projectAnalysisSuccess,
        projectAnalysisLoading,
        projectAnalysisError,
        refetchProjectAnalysisResults,
        keyActivityProvider,
        setKeyActivityProvider,
      }}
    >
      {children}
    </ProjectOverviewContext.Provider>
  );
};

ProjectOverviewProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useProjectOverviewContext = () =>
  useContext(ProjectOverviewContext);
